module.exports = __webpack_public_path__ + "91084741d108d56af3316af30168910a.svg";